import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {FormControl} from "@angular/forms";

@Component({
    selector: "fhm-cancel-reasons-select-control",
    templateUrl: "./cancel-reasons-select-control.component.html",
    styleUrls: ["./cancel-reasons-select-control.component.scss"],
    standalone: false
})
export class CancelReasonsSelectControlComponent implements OnChanges {
    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string> = new EventEmitter();

    @Input() public value: string;

    @Input() disabled: boolean;
    public options: any[] = [
        {label: "Breakdown with Partner", value: "Breakdown with Partner"},
        {label: "Business Closed", value: "Business Closed"},
        {label: "Business Sold - New Owner Doesn't Want", value: "Business Sold - New Owner Doesn't Want"},
        {label: "Business structure changed", value: "Business structure changed"},
        {label: "Cancelled Prior to ONB/Build", value: "Cancelled Prior to ONB/Build"},
        {label: "Connection/Printer/Technical Issues", value: "Connection/Printer/Technical Issues"},
        {label: "Decision maker did not agree", value: "Decision maker did not agree"},
        {label: "Did not have uptake from customers", value: "Did not have uptake from customers"},
        {label: "Doesn't suit customer needs", value: "Doesn't suit customer needs"},
        {label: "Duplicate Account", value: "Duplicate Account"},
        {label: "Forced cancellation/Cannot reach", value: "Forced cancellation/Cannot reach"},
        {label: "Incorrect Venue Style", value: "Incorrect Venue Style"},
        {label: "Integration not available", value: "Integration not available"},
        {label: "Legacy - Non Trading", value: "Legacy - Non Trading"},
        {label: "Locked in contract with competitor", value: "Locked in contract with competitor"},
        {label: "Lost to a competitor", value: "Lost to a competitor"},
        {label: "Misold/ Oversold / Unclear of contract", value: "Misold/ Oversold / Unclear of contract"},
        {label: "Not a priority for customer", value: "Not a priority for customer"},
        {label: "Pricing", value: "Pricing"},
        {label: "Product/ Features not suitable", value: "Product/ Features not suitable"},
        {label: "Service/ support", value: "Service/ support"},
        {label: "Wasn't supported/resistance by staff", value: "Wasn't supported/resistance by staff"}
    ];


    public selectedValue: any;


    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue["value"]);
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedValue = undefined;
        this.options.forEach(d => {
            if (d.value === this.value) {
                this.selectedValue = d;
            }
        });
    }

}
